var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconChat = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M5.25 18.75H8.50725L11.4698 21.7125C11.7622 22.0058 12.2378 22.0058 12.5303 21.7125L15.4928 18.75H18.75C20.3805 18.75 21.75 17.6085 21.75 16.125V4.875C21.75 3.39075 20.3805 2.25 18.75 2.25H5.25C3.6195 2.25 2.25 3.3915 2.25 4.875V16.125C2.25 17.6093 3.6195 18.75 5.25 18.75ZM15.1823 17.25C14.9835 17.25 14.7922 17.3287 14.652 17.4697L12.0007 20.121L9.3495 17.4697C9.2085 17.3287 9.018 17.25 8.81925 17.25H5.2515C4.395 17.25 3.7515 16.7137 3.7515 16.125V4.875C3.7515 4.28625 4.395 3.75 5.2515 3.75H18.7515C19.608 3.75 20.2515 4.28625 20.2515 4.875V16.125C20.2515 16.7137 19.608 17.25 18.7515 17.25H15.1838H15.1823ZM6 9C6 8.586 6.336 8.25 6.75 8.25H16.5C16.914 8.25 17.25 8.586 17.25 9C17.25 9.414 16.914 9.75 16.5 9.75H6.75C6.336 9.75 6 9.414 6 9ZM6.75 11.25C6.336 11.25 6 11.586 6 12C6 12.414 6.336 12.75 6.75 12.75H13.5C13.914 12.75 14.25 12.414 14.25 12C14.25 11.586 13.914 11.25 13.5 11.25H6.75Z", fill: "black" }))),
        alt: 'Icon Chat',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconChat;
//# sourceMappingURL=index.js.map